import { Milestone, MilestoneCreate, MilestoneUpdate } from '../types/milestone';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/milestones';

/**
 * Fetch all milestones, optionally filtered by project_id
 */
export const fetchMilestones = async (projectId?: string): Promise<Milestone[]> => {
  const url = projectId ? `${API_URL}/read?project_id=${projectId}` : `${API_URL}/read`;
  return await fetcher(url);
};

/**
 * Fetch a single milestone by ID
 */
export const getMilestoneById = async (id: string): Promise<Milestone> => {
  return await fetcher(`${API_URL}/read/${id}`);
};

/**
 * Create a new milestone
 */
export const createMilestone = async (data: MilestoneCreate): Promise<Milestone> => {
  return await fetcher(`${API_URL}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

/**
 * Update an existing milestone
 */
export const updateMilestone = async (id: string, data: MilestoneUpdate): Promise<Milestone> => {
  return await fetcher(`${API_URL}/update/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

/**
 * Delete a milestone (sets tasks.milestone_id to NULL via ON DELETE SET NULL)
 */
export const deleteMilestone = async (id: string): Promise<boolean> => {
  return await fetcher(`${API_URL}/delete/${id}`, {
    method: 'DELETE',
  });
};
